import { useIsMobile } from '../../utils'
import { TableDesktop } from './table-desktop'
import { TableMobile } from './table-mobile'
import { TableProps } from './types'

export const UsersTable = ({ users }: TableProps) => {
  const isMobile = useIsMobile()
  return isMobile ? <TableMobile users={users} /> : <TableDesktop users={users} />
}
